import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { NoAuthGuard } from '@app/guard/no-auth.guard';
import { AuthGuard } from '@app/guard/auth.guard';
import { environment } from '@env';


const routes: Routes = [
    {
        path: 'auth',
        component: AuthLayoutComponent,
        canActivate: [NoAuthGuard],
        loadChildren: () =>
            import('@modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'landpage',
        canActivate: [NoAuthGuard],
        loadChildren: () => import('@modules/land-page/land-page.module').then(m => m.LandPageModule)
    },
    {
        path: '',
        canActivate: [AuthGuard],
        component: ContentLayoutComponent,
        children: [
            // {
            //   path: 'welcome',
            //   loadChildren: () => import('@modules/welcome/welcome.module').then(m => m.WelcomeModule),
            //   component: WelcomeComponent
            // },
            {
                path: 'app',
                // canActivate: [CompanyGuard],
                children: [
                    {
                        path: 'tickets',
                        loadChildren: () => import('@modules/tickets/tickets.module').then(m => m.TicketsModule)
                    },
                    // {
                    //   path: 'menu',
                    //   loadChildren: () => import('@modules/menu/menu.module').then(m => m.MenuModule),
                    //   component: MenuComponent
                    // },
                    {
                        path: '**',
                        redirectTo: 'tickets',
                        pathMatch: 'full'
                    }
                ]
            },
            {
                path: '**',
                redirectTo: 'app',
                pathMatch: 'full'
            }
        ]
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
